export const SERVER_URL = "http://localhost:5000/";
export const PRODUCTION_SERVER_URL = "https://api.shutworld.ru/";